/*** IMPORTS FROM imports-loader ***/
var global = window;

export default function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
